/* istanbul ignore file: soon to be deleted file */
import { useEffect } from 'react';
import { useRouter } from 'next/router';

// Not related to predictions at all
export const useSetInputOnMount = (setCurrentInput: (id: string) => void, deps: React.DependencyList = []): void => {
  const { inputId } = useRouter().query as {
    inputId: string;
  };

  useEffect(() => {
    setCurrentInput(inputId);
  }, [...deps]);
};
